var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubAgents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 4.23858 4.23858 2 7 2C8.74183 2 10.2756 2.89067 11.1708 4.24141C10.4986 4.4229 9.86648 4.702 9.29057 5.06256C8.74027 4.41261 7.91832 4 7 4C5.34315 4 4 5.34315 4 7C4 8.34047 4.87916 9.4756 6.09233 9.86024C6.03159 10.2312 6 10.6119 6 11C6 11.3089 6.02001 11.6132 6.05881 11.9116C3.74734 11.4713 2 9.43969 2 7Z",
    fill: "#4F49DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67363 14H5C2.79086 14 1 15.7909 1 18V19H3V18C3 16.8954 3.89543 16 5 16H8.10102C7.51513 15.4259 7.02973 14.7496 6.67363 14Z",
    fill: "#4F49DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H17.899C18.4849 15.4259 18.9703 14.7496 19.3264 14H21C23.2091 14 25 15.7909 25 18V19H23V18C23 16.8954 22.1046 16 21 16Z",
    fill: "#4F49DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9412 11.9116C22.2527 11.4713 24 9.43969 24 7C24 4.23858 21.7614 2 19 2C17.2582 2 15.7244 2.89067 14.8292 4.24141C15.5014 4.4229 16.1335 4.702 16.7094 5.06256C17.2597 4.41261 18.0817 4 19 4C20.6569 4 22 5.34315 22 7C22 8.34047 21.1208 9.4756 19.9077 9.86024C19.9684 10.2312 20 10.6119 20 11C20 11.3089 19.98 11.6132 19.9412 11.9116Z",
    fill: "#4F49DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C8 8.23858 10.2386 6 13 6C15.7614 6 18 8.23858 18 11C18 13.7614 15.7614 16 13 16C10.2386 16 8 13.7614 8 11ZM13 8C11.3431 8 10 9.34315 10 11C10 12.6569 11.3431 14 13 14C14.6569 14 16 12.6569 16 11C16 9.34315 14.6569 8 13 8Z",
    fill: "#4F49DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C7.79086 18 6 19.7909 6 22V23H8V22C8 20.8954 8.89543 20 10 20H16C17.1046 20 18 20.8954 18 22V23H20V22C20 19.7909 18.2091 18 16 18H10Z",
    fill: "#4F49DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 4.23858 4.23858 2 7 2C8.74183 2 10.2756 2.89067 11.1708 4.24141C10.4986 4.4229 9.86648 4.702 9.29057 5.06256C8.74027 4.41261 7.91832 4 7 4C5.34315 4 4 5.34315 4 7C4 8.34047 4.87916 9.4756 6.09233 9.86024C6.03159 10.2312 6 10.6119 6 11C6 11.3089 6.02001 11.6132 6.05881 11.9116C3.74734 11.4713 2 9.43969 2 7Z",
    stroke: "#4F49DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 4.23858 4.23858 2 7 2C8.74183 2 10.2756 2.89067 11.1708 4.24141C10.4986 4.4229 9.86648 4.702 9.29057 5.06256C8.74027 4.41261 7.91832 4 7 4C5.34315 4 4 5.34315 4 7C4 8.34047 4.87916 9.4756 6.09233 9.86024C6.03159 10.2312 6 10.6119 6 11C6 11.3089 6.02001 11.6132 6.05881 11.9116C3.74734 11.4713 2 9.43969 2 7Z",
    stroke: "#4F49DF",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67363 14H5C2.79086 14 1 15.7909 1 18V19H3V18C3 16.8954 3.89543 16 5 16H8.10102C7.51513 15.4259 7.02973 14.7496 6.67363 14Z",
    stroke: "#4F49DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67363 14H5C2.79086 14 1 15.7909 1 18V19H3V18C3 16.8954 3.89543 16 5 16H8.10102C7.51513 15.4259 7.02973 14.7496 6.67363 14Z",
    stroke: "#4F49DF",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H17.899C18.4849 15.4259 18.9703 14.7496 19.3264 14H21C23.2091 14 25 15.7909 25 18V19H23V18C23 16.8954 22.1046 16 21 16Z",
    stroke: "#4F49DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H17.899C18.4849 15.4259 18.9703 14.7496 19.3264 14H21C23.2091 14 25 15.7909 25 18V19H23V18C23 16.8954 22.1046 16 21 16Z",
    stroke: "#4F49DF",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9412 11.9116C22.2527 11.4713 24 9.43969 24 7C24 4.23858 21.7614 2 19 2C17.2582 2 15.7244 2.89067 14.8292 4.24141C15.5014 4.4229 16.1335 4.702 16.7094 5.06256C17.2597 4.41261 18.0817 4 19 4C20.6569 4 22 5.34315 22 7C22 8.34047 21.1208 9.4756 19.9077 9.86024C19.9684 10.2312 20 10.6119 20 11C20 11.3089 19.98 11.6132 19.9412 11.9116Z",
    stroke: "#4F49DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9412 11.9116C22.2527 11.4713 24 9.43969 24 7C24 4.23858 21.7614 2 19 2C17.2582 2 15.7244 2.89067 14.8292 4.24141C15.5014 4.4229 16.1335 4.702 16.7094 5.06256C17.2597 4.41261 18.0817 4 19 4C20.6569 4 22 5.34315 22 7C22 8.34047 21.1208 9.4756 19.9077 9.86024C19.9684 10.2312 20 10.6119 20 11C20 11.3089 19.98 11.6132 19.9412 11.9116Z",
    stroke: "#4F49DF",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C8 8.23858 10.2386 6 13 6C15.7614 6 18 8.23858 18 11C18 13.7614 15.7614 16 13 16C10.2386 16 8 13.7614 8 11ZM13 8C11.3431 8 10 9.34315 10 11C10 12.6569 11.3431 14 13 14C14.6569 14 16 12.6569 16 11C16 9.34315 14.6569 8 13 8Z",
    stroke: "#4F49DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C8 8.23858 10.2386 6 13 6C15.7614 6 18 8.23858 18 11C18 13.7614 15.7614 16 13 16C10.2386 16 8 13.7614 8 11ZM13 8C11.3431 8 10 9.34315 10 11C10 12.6569 11.3431 14 13 14C14.6569 14 16 12.6569 16 11C16 9.34315 14.6569 8 13 8Z",
    stroke: "#4F49DF",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C7.79086 18 6 19.7909 6 22V23H8V22C8 20.8954 8.89543 20 10 20H16C17.1046 20 18 20.8954 18 22V23H20V22C20 19.7909 18.2091 18 16 18H10Z",
    stroke: "#4F49DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C7.79086 18 6 19.7909 6 22V23H8V22C8 20.8954 8.89543 20 10 20H16C17.1046 20 18 20.8954 18 22V23H20V22C20 19.7909 18.2091 18 16 18H10Z",
    stroke: "#4F49DF",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAgents);
export default __webpack_public_path__ + "static/media/subAgents.8d8a144e.svg";
export { ForwardRef as ReactComponent };